<template>
    <div>
        <div v-if="curShowPage=='list'">
            <div class="filter-bar mb10">
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="">
                        <el-input v-model="tempQuery.task_search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="请输入任务名称、任务编号搜索" style="width: 260px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <ESelect
                            class="select-tags-width"
                            v-model="tempQuery.account_id"
                            placeholder="账户筛选，支持名称、ID搜索"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="(query) => remoteMethod(query, 'creator')"
                            :loading="searchAccountLoading"
                                   style="width: 220px">
                            <el-option v-for="item in filterAccountOptions" :key="item.id"
                                       :label="item.name + '(' + item.id + ')'" :value="item.id">
                                <span style="float: left">{{ item.name }}（{{ item.id }}）</span>
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="">
                        <ESelect
                            class="select-tags-width"
                            v-model="tempQuery.subitem_id"
                            placeholder="产品筛选，支持名称、ID、包名搜索"
                            style="width: 220px"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="(query) => remoteMethod(query, 'app')"
                            :loading="searchAppLoading"
                        >
                            <el-option v-for="item in filterAppOptions" :key="item.subitem_id"
                                       :label="item.subproject_name + '(' + item.subproject_id + ')' + '(' + item.subproject_content + ')'" :value="item.subitem_id">
                                <span style="float: left">{{ item.subproject_name }}（{{ item.subproject_id }}）{{item.subproject_content ? `（${item.subproject_content}）` : ''}}</span>
                            </el-option>
                        </ESelect>
                    </el-form-item>

                    <el-form-item label="">
                        <!-- <el-select v-model="tempQuery['plat_id']" multiple  collapse-tags filterable :placeholder="'媒体'"  style="width: 150px;">
                            <el-option :label="option.name" :value="option.id" v-for="option in isAllowedPlatList"
                                :key="option.id"></el-option>
                        </el-select> -->
                        <SelectAll :options="isAllowedPlatList" v-model="tempQuery['plat_ids']" :placeholder="'媒体'"/>
                    </el-form-item>

                    <el-form-item label="">
                        <ESelect v-model="tempQuery.template_id" placeholder="模板筛选" style="width: 175px"
                                   class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option :label="option.template_name" :value="option.template_id"
                                       v-for="option in filterTempOptions" :key="option.template_id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.send_status" placeholder="发送状态" style="width: 165px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="未发送" value="0"></el-option>
                            <el-option label="已发送" value="1"></el-option>
                            <el-option label="发送中" value="2"></el-option>
                            <el-option label="发送失败" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.status" placeholder="定时生成状态" style="width: 140px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="开启" value="1"></el-option>
                            <el-option label="关闭" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempQuery.auto_send" placeholder="自动发送状态" style="width: 140px" class="select-tags-width" multiple collapse-tags clearable filterable>
                            <el-option label="开启" value="1"></el-option>
                            <el-option label="关闭" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <ESelect v-model="tempQuery.user_ids" class="select-tags-width" multiple collapse-tags clearable filterable placeholder="归属人" style="width: 150px;">
                            <el-option v-for="item in userList" :label="item.creator" :value="item.uid" :key="item.uid">
                                {{item.creator}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="">
                        <ESelect v-model="tempQuery.group_id" class="select-tags-width" multiple collapse-tags clearable filterable placeholder="归属人部门" style="width: 175px;">
                            <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>

                    <el-form-item label="">
                        <el-button size="mini" type="primary" :loading="dataLoading" @click="submitSearch" style="width: 75px;" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '筛选'}">筛选</el-button>
                        <el-button size="mini" @click="resetForm" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '重置筛选'}">重置筛选</el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div class="table-tool-bar clearfix mb10">
                <div class="fl">
                    <el-button type="primary" v-if="pageFuncNames.includes('daily_task_feature')" @click="showCreatePage"  size="mini" class="mr10" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '创建任务'}">创建任务</el-button>
                    <el-popconfirm
                        :disabled="rowSelected.length<=0"
                        v-if="pageFuncNames.includes('daily_task_button')"
                        :title="'是否批量生成报告？'"
                        @confirm="batchGen"
                        @cancel="cancelBatchGen"
                    >
                        <el-button slot="reference" type="primary" :disabled="rowSelected.length<=0" :loading="batchGenLoading" plain size="mini" class="mr10" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '批量生成'}">批量生成</el-button>
                    </el-popconfirm>
                    <el-popconfirm
                        :disabled="rowSelected.length<=0"
                        v-if="pageFuncNames.includes('daily_task_button')"
                        :title="'是否批量发送报告？'"
                        @confirm="batchSend"
                        @cancel="cancelBatchSend"
                    >
                        <el-button slot="reference" type="success" :disabled="rowSelected.length<=0" :loading="batchSendLoading" plain size="mini" class="mr10" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '批量发送'}">批量发送</el-button>
                    </el-popconfirm>

                    <!--<el-button type="primary" v-if="pageFuncNames.includes('daily_task_button')" @click="batchGen" :disabled="rowSelected.length<=0" :loading="batchGenLoading" plain size="mini" class="mr10">批量生成</el-button>-->
                    <!--<el-button type="success" v-if="pageFuncNames.includes('daily_task_button')" @click="batchSend" :disabled="rowSelected.length<=0" :loading="batchSendLoading" plain size="mini" class="mr10">批量发送</el-button>-->
                    <el-button type="primary" v-if="pageFuncNames.includes('daily_task_transfer')" @click="pushTask" :disabled="rowSelected.length<=0" plain size="mini" class="mr10" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '转让'}">转让</el-button>
                </div>
            </div>
            <div class="data-list">
                <jt-table
                    key="task-table"
                    ref="dataTable"
                    :data="dataList"
                    v-loading="dataLoading"
                    @selection-change="rowSelectionChange"
                    tooltip-effect="dark"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    stripe
                    style="width: 100%;">
                    <el-table-column
                        fixed
                        type="selection"
                        align="center"
                        width="60">
                    </el-table-column>
                    <el-table-column
                        prop="task_number"
                        label="任务编号"
                        align="center"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        prop="task_name"
                        show-overflow-tooltip
                        label="任务名称"
                        align="center"
                        min-width="200">
                        <template slot-scope="scope">
                            <span class="text-color-primary pointer" @click="toDetailPage(scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(任务详情)'}">{{scope.row.task_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="定时生成开关"
                        align="center"
                        min-width="120">
                        <template slot-scope="scope">
                            <el-switch
                                v-if="pageFuncNames.includes('daily_task_feature')"
                                class="mini-switch"
                                :value="scope.row.status"
                                :disabled="scope.row.statusLoading"
                                @change="changeTaskStatus(scope.row,$event)"
                                active-value="1"
                                inactive-value="0"
                            ></el-switch>
                            <span v-else>{{scope.row.status=='1'?'开':scope.row.status=='0'?'关':'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="auto_send"
                        label="自动发送"
                        align="center"
                        min-width="120">
                        <template slot="header" slot-scope="scope">
                            自动发送
                            <el-tooltip class="item" effect="dark" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content" style="max-width: 300px;">
                                    <p style="line-height: 1.5;" class="mb10">当开关为开启时，自动生成结束后自动发送该自动化报告至配置的接收人。</p>
                                    <p style="line-height: 1.5;">需要与定时生成配合使用，手动生成的自动化报告不会自动发送，需要手动发送。</p>
                                </div>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <el-switch
                                v-if="pageFuncNames.includes('daily_task_autosend')"
                                class="mini-switch"
                                :value="scope.row.auto_send"
                                :disabled="scope.row.autoSendLoading"
                                @change="changeAutoSend(scope.row,$event)"
                                active-value="1"
                                inactive-value="0"
                            ></el-switch>
                            <span v-else>{{scope.row.auto_send=='1'?'开':scope.row.auto_send=='0'?'关':'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="plat_names"
                        label="媒体"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.row.plat_names || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_generate_status"
                        label="上次生成状态"
                        align="center"
                        min-width="150">
                        <template slot-scope="scope">
                           <p>
                               <span class="mr10">成功(<span class="text-color-success">{{scope.row.last_generate_status.success}}</span>)</span>
                               <span>失败(<span class="text-color-error">{{scope.row.last_generate_status.fail}}</span>)</span>
                           </p>
                            <p>
                                <span class="mr10">进行中(<span>{{scope.row.last_generate_status.inProgress}}</span>)</span>
                                <span>未开启(<span>{{scope.row.last_generate_status.unExecuted}}</span>)</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_generate_time"
                        label="上次生成时间"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.last_generate_time}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="total_time"
                        label="生成耗时"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.total_time==='0'||scope.row.total_time===0">0秒</span>
                            <span v-else-if="!scope.row.total_time">--</span>
                            <span v-else>{{secondToDuration(scope.row.total_time)||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_send_status"
                        label="发送状态"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.last_send_status == '1'" class="text-color-success">已发送</span>
                            <span v-else-if="scope.row.last_send_status == '2'" class="text-color-warn">发送中</span>
                            <div v-else-if="scope.row.last_send_status == '3'" class="pointer">
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <span class="mr4 text-color-failed">发送失败
                                        <i class="el-icon-warning-outline text-color-failed"></i>
                                    </span>
                                    <div slot="content" style="max-width: 500px;max-height: 300px;overflow-y: auto;" class="break-word">
                                        <div v-if="scope.row.send_error_info" v-html="scope.row.send_error_info"></div>
                                        <span v-else>发送失败</span>
                                    </div>
                                </el-tooltip>
                            </div>
                            <span v-else>未发送</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="last_send_time"
                        label="发送时间"
                        align="center"
                        width="100">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.last_send_time}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="generate_time_format"
                        label="定时生成时间"
                        align="center"
                        min-width="250">
                        <template slot-scope="scope">
                            <p>{{scope.row.generate_frequency_format}}</p>
                            <p>{{scope.row.generate_time_format}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="body"
                        label="邮件信息"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span class="text-color-primary pointer" @click="viewMailInfo(scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(邮件信息)'}">查看</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="creator"
                        label="归属人"
                        align="center"
                        min-width="100">
                    </el-table-column>
                    <el-table-column
                        prop="ctime"
                        label="创建日期"
                        align="center"
                        min-width="90">
                        <template slot-scope="scope">
                            <p style="max-width: 70px;">{{scope.row.ctime}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="action"
                        label="操作"
                        align="center"
                        min-width="190">
                        <template slot-scope="scope">
                            <template v-if="pageFuncNames.includes('daily_task_button')">
                                <el-popconfirm
                                    v-if="scope.row.last_generate_status.inProgress<=0"
                                    :title="'是否生成报告：'+scope.row.task_name+'？'"
                                    @confirm="genTask(scope.row)"
                                >
                                    <span class="text-color-primary pointer mr10" slot="reference" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(生成)'}">生成</span>
                                </el-popconfirm>
                                <span v-else class="text-color-primary pointer mr10 disabled" @click="genTask(scope.row)" title="该任务正在生成中，请稍后再试" slot="reference" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(生成)'}">生成</span>
                            </template>
                            <el-button class="text-success mr10" :disabled="scope.row.sendLoading" type="text" v-if="pageFuncNames.includes('daily_task_button')" @click="sendTask(scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(发送)'}">发送</el-button>
                            <!--<el-button class="topBtn mr10" type="text" v-if="scope.row.is_top!='1'"   size="small"  :loading="scope.row.topLoading"  @click="setTaskTop(scope.row)">置顶</el-button>-->
                            <!--<el-button class="topBtn mr10" type="text" v-else    size="small"  :loading="scope.row.topLoading"  @click="setTaskTop(scope.row)">取消置顶</el-button>-->

                            <span :class="[scope.row.topLoading?'disabled':'']" class="topBtn font12px text-bold pointer mr10 icon iconfont icon-jt-zhiding" v-if="scope.row.is_top!='1'" @click="setTaskTop(scope.row)" title="置顶" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(置顶)'}"></span>
                            <span :class="[scope.row.topLoading?'disabled':'']" class="topBtn font12px text-bold pointer mr10 icon iconfont icon-jt-zhiding text-color-primary" v-else @click="setTaskTop(scope.row)" title="取消置顶"></span>

                            <el-dropdown @command="handleCommand(scope.row,$event)">
                                <span class="el-dropdown-link pointer">更多<i class="el-icon-arrow-down el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit" v-if="pageFuncNames.includes('daily_task_feature')" :disabled="scope.row.last_generate_status.inProgress!='0'" :title="scope.row.last_generate_status.inProgress!='0'?'生成中的报告不可编辑':''" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(编辑)'}">编辑</el-dropdown-item>
                                    <el-dropdown-item command="record" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(生成记录)'}">生成记录</el-dropdown-item>
                                    <!--<el-dropdown-item command="position">调整位置</el-dropdown-item>-->
                                    <el-dropdown-item command="delete"
                                                      v-if="pageFuncNames.includes('daily_task_feature')"
                                                      :disabled="scope.row.last_generate_status.inProgress!='0'"
                                                      :title="scope.row.last_generate_status.inProgress!='0'?'生成中的报告不可删除':''"
                                    ><span :class="[scope.row.last_generate_status.inProgress!='0'?'':'text-color-error']" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: '列表(删除)'}">删除</span></el-dropdown-item>
                                </el-dropdown-menu>

                            </el-dropdown>
                        </template>
                    </el-table-column>
                </jt-table>
            </div>

            <div class="page-bar tac mt20">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-sizes="[30,50,100]"
                    :page-size="queryData.rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>

            <MailInfoModal ref="mailInfoModal" :data="actionRow" :type="actionType" @update="getDataList" />
            <PositionModal ref="posModal" :data="actionRow" @update="getDataList" />
            <PushModal ref="pushModal" :data="rowSelected" @update="getDataList"/>
            <ErrTipModal ref="errTipModal" @ok="confirmErrTip"/>
        </div>
        <div v-else-if="curShowPage=='create'">
            <CreatePage ref="createPage" :allowed-plat-list="allowedPlatList" :data="actionRow" :page-func-names="pageFuncNames" :type="actionType" @back="showListPage" @update="getDataList"/>
        </div>
        <div v-else-if="curShowPage=='detail'">
            <DetailPage ref="detailPage" :allowed-plat-list="allowedPlatList" :data="actionRow" :page-func-names="pageFuncNames" @back="showListPage" @update="getDataList" @edit="editTask"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CreatePage from './create';
    import SelectAll from '@/components/SelectAll';
    import DetailPage from './detailList';
    import MailInfoModal from './modal/mailInfoModal';
    import PositionModal from './modal/positionModal';
    import PushModal from './modal/pushModal';
    import API from '@/api/efficiencyTool/task.js';
    import utils from '@/libs/utils.js';
    import ErrTipModal from '../../modal/errorTipModal';
    import matomoFun from "@/utils/matomo.js";
    export default {
        name: "TaskList",
        components:{
            CreatePage,
            DetailPage,
            MailInfoModal,
            PositionModal,
            PushModal,
            ErrTipModal,
            SelectAll
        },
        props:{
            allowedPlatList:Array,
            pageFuncNames:Array,
        },
        data(){
            return {
                curShowPage:'list',
                dataLoading:false,
                queryData:{
                    task_search:'',
                    user_ids:[],
                    group_id:[],
                    account_id:[],
                    subitem_id:[],
                    template_id:[],
                    send_status:[],
                    status:[],
                    auto_send:[],
                    plat_ids: [],
                    pn: 1,
                    rn: 30,
                },
                tempQuery:{
                    task_search:'',
                    user_ids:[],
                    group_id:[],
                    account_id:[],
                    subitem_id:[],
                    template_id:[],
                    send_status:[],
                    status:[],
                    auto_send:[],
                    plat_ids: []
                },
                userList:[],
                groupList:[],
                filterAccountOptions: [],
                filterAppOptions: [],
                filterTempOptions:[],
                searchAppLoading:false,
                searchAccountLoading:false,
                batchGenLoading:false,
                batchSendLoading:false,
                dataList:[],
                totalCnt:0,
                rowSelected:[],
                actionRow:{},
                actionType:'',
                refreshTimer:null,
            }
        },
        computed:{
            ...mapGetters(['name','user_id']),
            isAllowedPlatList() {
                return this.allowedPlatList;
            }
        },
        mounted(){
            this.getSelectOptions();
            // this.submitSearch();
            this.startRefresh();
        },
        watch:{
            curShowPage(val){
                let isListPage = val==='list';
                if(isListPage){
                    console.log('startRefresh');
                    if(!this.refreshTimer){
                        this.startRefresh();
                    }
                }else {
                    console.log('stopRefresh');
                    this.stopRefresh();
                }
            },
        },
        methods:{
            searchList(data){
                if(this.curShowPage!='list'){
                    this.curShowPage = 'list';
                }
                this.resetForm(data);
                if(data.template_id){
                    this.tempQuery.template_id = [data.template_id];
                }
                if(data.search){
                    this.tempQuery.task_search = data.search;
                }

                this.submitSearch(data.detail);
            },
            getSelectOptions(){
                /* 获取归属人下拉列表 */
                API.getUserOptions().then(res=>{
                    this.userList = res.data||[];

                    let userData = this.userList.find(item=>item.uid==this.user_id&&item.creator==this.name);
                    if(!userData){
                        this.userList.push({
                            uid:this.user_id,
                            creator:this.name,
                        })
                    }
                    this.tempQuery.user_ids = [this.user_id];
                },err=>{
                    console.log('getUserOptions',err);
                    this.userList = [{
                        uid:this.user_id,
                        creator:this.name,
                    }];
                });

                /* 获取归属部门下拉列表 */
                API.getGroupOptions().then(res=>{
                    this.groupList = res.data||[];
                },err=>{
                    console.log('getGroupOptions',err);
                    this.groupList = [];
                });

                /* 获取模板下拉列表*/
                API.getSearchTemplateList().then(res=>{
                    this.filterTempOptions = res.data||[];
                },err=>{
                    console.log('getGroupOptions',err);
                    this.filterTempOptions = [];
                });
            },
            remoteMethod(query, type) {
                if (!query){
                    if (type == 'creator') {
                        return this.filterAccountOptions = [];
                    } else {
                        return this.filterAppOptions = [];
                    }
                }
                if(type === 'creator'){
                    this.searchAccountLoading = true;
                }else{
                    this.searchAppLoading = true;
                }

                API.getSearchOptions({
                    search_type: type,
                    search: query,
                    source:'task',      // task-任务页面,record-任务记录页面
                }).then(res => {
                    let result = res.data||[];
                    if (type == 'creator') {
                        this.filterAccountOptions = result;
                        this.searchAccountLoading = false;
                    } else {
                        this.filterAppOptions = result;
                        this.searchAppLoading = false;
                    }
                });
            },
            getDataList(isToDetail){
                console.log('getDataList');
                this.dataLoading = true;
                API.getTaskList({
                    task_search:this.queryData.task_search,
                    user_ids:this.queryData.user_ids,
                    group_id:this.queryData.group_id,
                    status:this.queryData.status,
                    auto_send:this.queryData.auto_send,
                    send_status:this.queryData.send_status,
                    template_id:this.queryData.template_id,
                    subitem_ids:this.queryData.subitem_id,
                    account_id:this.queryData.account_id,
                    plat_ids: this.queryData.plat_ids,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = (resData.list || []).map(item=>{
                        item.genLoading = false;
                        item.sendLoading = false;
                        item.statusLoading = false;
                        item.autoSendLoading = false;
                        item.topLoading = false;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;

                    if(isToDetail){
                        let searchText = this.$route.params.search||this.$route.query.search;
                        let actionRow = this.dataList.find(item=>item.task_number==searchText);
                        if(actionRow){
                            this.$nextTick(()=>{
                                this.toDetailPage(actionRow);
                            })
                        }else{
                            this.$message.error('该任务不存在');
                        }
                    }
                }, (err) => {
                    console.log('getTaskList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            resetForm(data){

                let userData = this.userList.find(item=>item.uid==this.user_id&&item.creator==this.name);
                if(userData&&!data.search){
                    this.tempQuery.user_ids = [userData.uid];
                }else{
                    this.tempQuery.user_ids = [this.user_id];
                }


                this.tempQuery.task_search = '';

                this.tempQuery.group_id = [];
                this.tempQuery.subitem_id = [];
                this.tempQuery.account_id = [];
                this.tempQuery.template_id = [];
                this.tempQuery.send_status = [];
                this.tempQuery.status = [];
                this.tempQuery.auto_send = [];
                this.tempQuery.plat_ids = [];

                this.queryData.pn = 1

                setTimeout(()=>{
                    this.submitSearch();
                },0);
            },
            submitSearch(isToDetail){
                this.queryData.gr = 1;
                this.queryData.task_search = this.tempQuery.task_search;
                this.queryData.user_ids = this.tempQuery.user_ids;
                this.queryData.group_id = this.tempQuery.group_id;
                this.queryData.template_id = this.tempQuery.template_id;
                this.queryData.send_status = this.tempQuery.send_status;
                this.queryData.status = this.tempQuery.status;
                this.queryData.auto_send = this.tempQuery.auto_send;
                this.queryData.account_id = this.tempQuery.account_id;
                this.queryData.subitem_id = this.tempQuery.subitem_id;
                this.queryData.plat_ids = this.tempQuery.plat_ids;
                if(!this.isEvent(isToDetail)||isToDetail===true){
                    this.getDataList(isToDetail);
                }else{
                    this.getDataList();
                }
            },
            showCreatePage(){
                console.log('showCreatePage');
                this.actionType = 'add';
                this.actionRow = {};
                this.curShowPage = 'create';
            },
            cancelBatchGen(){
                // , event: '点击',  name: '创建任务'}"
                matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '批量生成(取消)');
            },
            batchGen(){
                if(this.rowSelected.length<=0) return false;
                matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '批量生成(确定)');
                let taskIds = this.rowSelected.map(item=>item.task_id);
                this.batchGenLoading = true;

                API.checkTaskPerm({
                    task_id:taskIds.join(','),
                }).then(()=>{
                    API.genTask({
                        task_id:taskIds.join(','),
                    }).then(res=>{
                        this.batchGenLoading = false;
                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'任务创建成功，正在生成');
                        }else{
                            this.$notify.error({
                                title: '部分报告生成失败:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                    },err=>{
                        console.log('batchGen err',err);
                        this.batchGenLoading = false;
                        let errData = err.data||[];
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'以下报告生成失败:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'操作失败');
                        }
                    });
                },err=>{
                    this.batchGenLoading = false;
                    console.log('batch checkTaskPerm err',err);
                    if(err.code==403){
                        return this.$message.error(err.info||'请求异常');
                    }
                    let errData = err.data||{};
                    let errList = errData.error_auth||[];
                    this.$refs.errTipModal.showModal({
                        title:err.info||'以下账户无权限，无法生成该文件，是否继续生成?',
                        subTitle:'继续则将无权限文件状态关闭，继续生成其他文件',
                        actionType:'batchGenTask',
                        errList:errList,
                        actionData:taskIds.join(','),
                        isConfirm:true,
                    });
                });

            },
            cancelBatchSend(){
                matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '批量发送(取消)');
            },
            batchSend(){
                if(this.rowSelected.length<=0) return false;
                matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '批量发送(确定)');
                let taskIds = this.rowSelected.map(item=>item.task_id);
                this.batchSendLoading = true;
                API.batchSendTask({
                    task_id:taskIds.join(','),
                }).then(res=>{
                    this.batchSendLoading = false;
                    // this.$message.success(res.info||'请求成功');
                    let resData = res.data||{};
                    let errList = resData.error||[];
                    if(errList.length<=0){
                        this.$message.success(res.info||'任务创建成功，正在发送');
                    }else{
                        this.$notify.error({
                            title: '部分报告发送失败:',
                            dangerouslyUseHTMLString: true,
                            message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                            duration: 0
                        });
                    }
                    this.getDataList();
                },err=>{
                    console.log('batchGen err',err);
                    this.batchSendLoading = false;
                    let errData = err.data;

                    if(Array.isArray(errData)){
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'以下报告发送失败:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'操作失败');
                        }
                    }else{
                        if(err.code==403){
                            return this.$message.error(err.info||'请求异常');
                        }
                        let errList = (errData||{}).error_auth||[];
                        this.$refs.errTipModal.showModal({
                            title:err.info||'以下账户无权限，无法发送',
                            subTitle:'您可确认权限后重新点击发送，若可忽略无权限文件，重新生成后再次发送即可',
                            actionType:'batchSendTask',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }

                });
            },
            pushTask(){
                console.log('pushTask');
                if(this.rowSelected.length<=0) return false;
                this.$refs.pushModal.showModal();
            },
            rowSelectionChange(val){
                this.rowSelected = val.map(item => item);
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            showListPage(){
                this.curShowPage = 'list';
            },
            viewMailInfo(row){
                console.log('viewMailInfo',row);
                this.actionRow = {...row};
                this.actionType = 'view';
                this.$nextTick(()=>{
                    this.$refs.mailInfoModal.showModal();
                });
            },
            genTask(row){
                if(row.genLoading) return console.log('loading');
                if(row.last_generate_status.inProgress>0) return this.$message.warning('该任务正在生成中，请稍后再试');
                row.genLoading = true;

                API.checkTaskPerm({
                    task_id:row.task_id,
                }).then(()=>{
                    API.genTask({
                        task_id:row.task_id,
                    }).then(res=>{
                        console.log('genTask',res);
                        row.genLoading = false;

                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'任务创建成功，正在生成');
                        }else{
                            this.$notify.error({
                                title: '部分报告生成失败:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px mb6">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                    },err=>{
                        console.log('genTask err',err);
                        row.genLoading = false;
                        this.$message.error(err.info||'请求失败');
                    })
                },err=>{
                    row.genLoading = false;
                    console.log('checkTaskPerm err',err);
                    if(err.code==403){
                        return this.$message.error(err.info||'请求异常');
                    }
                    let errData = err.data||{};
                    let errList = errData.error_auth||[];
                    this.$refs.errTipModal.showModal({
                        title:err.info||'以下账户无权限，无法生成该文件，是否继续生成?',
                        subTitle:'继续则将无权限文件状态关闭，继续生成其他文件',
                        actionType:'genTask',
                        isConfirm:true,
                        errList:errList,
                        actionData:row,
                    });
                });
            },
            confirmErrTip(type,data){
                if(type=='genTask'){
                    let actionData = this.dataList.find(item=>item.task_id == data.task_id);
                    API.genTask({
                        task_id:data.task_id,
                    }).then(res=>{
                        console.log('genTask',res);
                        this.$refs.errTipModal.setOkLoading(false);
                        actionData.genLoading = false;

                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'任务创建成功，正在生成');
                        }else{
                            this.$notify.error({
                                title: '部分报告生成失败:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px mb6">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                        this.$refs.errTipModal.hideModal();
                    },err=>{
                        console.log('genTask err',err);
                        actionData.genLoading = false;
                        this.$refs.errTipModal.setOkLoading(false);
                        this.$message.error(err.info||'请求失败');
                    })
                }else if(type=='batchGenTask'){
                    this.batchGenLoading = true;
                    API.genTask({
                        task_id:data,
                    }).then(res=>{
                        this.$refs.errTipModal.setOkLoading(false);
                        this.batchGenLoading = false;
                        let resData = res.data||{};
                        let errList = resData.error||[];
                        if(errList.length<=0){
                            this.$message.success(res.info||'任务创建成功，正在生成');
                        }else{
                            this.$notify.error({
                                title: '部分报告生成失败:',
                                dangerouslyUseHTMLString: true,
                                message: '<div style="max-height: 200px;overflow-y: auto;" class="pr10">'+errList.map(item=>`<p class="font12px" style="margin-bottom: 6px;">${item}</p>`).join('')+'</div>',
                                duration: 0
                            });
                        }
                        this.getDataList();
                        this.$refs.errTipModal.hideModal();
                    },err=>{
                        console.log('batchGen err',err);
                        this.batchGenLoading = false;
                        this.$refs.errTipModal.setOkLoading(false);
                        let errData = err.data||[];
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'以下报告生成失败:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'操作失败');
                        }
                    });
                }
            },
            sendTask(row){
                console.log('sendTask',row);
                row.sendLoading = true;
                API.getTaskMailInfo({
                    task_id:row.task_id,
                }).then(()=>{
                    row.sendLoading = false;
                    this.actionRow = {...row};
                    this.actionType = 'send';
                    this.$refs.mailInfoModal.showModal();
                },err=>{
                    // this.$message.error(err.info||'请求失败');
                    row.sendLoading = false;

                    let errData = err.data||{};
                    if(Array.isArray(errData)){
                        if(err.code==0&&errData.length>0){
                            this.$notify.error({
                                title: err.info||'以下报告发送失败:',
                                message: errData.map(item=>item).join('；'),
                                duration: 0
                            });
                        }else{
                            this.$message.error(err.info||'操作失败');
                        }
                    }else{
                        if(err.code==403){
                            return this.$message.error(err.info||'请求异常');
                        }
                        let errList = (errData||{}).error_auth||[];
                        this.$refs.errTipModal.showModal({
                            title:err.info||'以下账户无权限，无法发送',
                            subTitle:'您可确认权限后重新点击发送，若可忽略无权限文件，重新生成后再次发送即可',
                            actionType:'sendTask',
                            isConfirm:false,
                            errList:errList,
                            actionData:'',
                        });
                    }

                });
            },
            setTaskTop(row){
                if(row.topLoading) return false;
                let taskId = row.task_id;
                let curTopStatus = row.is_top;
                row.topLoading = true;
                API.setTaskTop({
                    task_id:taskId,
                    is_top:curTopStatus=='1'?'0':'1'
                }).then(res=>{
                    row.topLoading = false;
                    this.$message.success(res.info||'修改成功');
                    this.getDataList();
                },err=>{
                    console.log('setTaskTop err',err);
                    row.topLoading = false;
                    this.$message.error(err.info||'修改失败');
                });
            },
            handleCommand(data,val){
                console.log('handleCommand',data,val);
                switch (val) {
                    case 'edit':
                        this.actionType = 'edit';
                        this.actionRow = {...data};
                        this.curShowPage = 'create';
                        this.$nextTick(()=>{
                            this.$refs.createPage.setData();
                        });
                        break;
                    case 'record':
                        this.toRecordPage({...data});
                        break;
                    case 'position':
                        this.actionRow = {...data};
                        this.$refs.posModal.showModal();
                        break;
                    case 'delete':
                        this.$alert('您确定要删除任务：<span class="text-bold">'+data.task_name+'</span> 吗？', {
                            type:'error',
                            confirmButtonText:'确认删除',
                            confirmButtonClass:'danger-button',
                            showCancelButton:true,
                            dangerouslyUseHTMLString:true,
                        }).then(()=>{
                            matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '列表(删除-确认删除)');
                            API.deleteTask({
                                task_id:data.task_id,
                            }).then(res=>{
                                this.$message.success(res.info||'操作成功');
                                this.getDataList();
                            },err=>{
                                console.log('deleteTask err',err);
                                this.$message.error(err.info||'操作失败');
                            })
                        }).catch(()=>{
                            console.log('取消删除');
                            matomoFun.trackEvent('自动化报告(任务报告列表)', '点击', '列表(删除-取消)');
                        });
                        break;
                }
            },
            toRecordPage(row){
                console.log('toRecordPage',row);
                this.$emit('toRecordPage',row);
            },
            changeTaskStatus(row,val){
                console.log('changeTaskStatus',row,val);
                row.statusLoading = true;
                API.changeTaskStatus({
                    task_id:row.task_id,
                    status:val,
                }).then(res=>{
                    row.statusLoading = false;
                    row.status = val;
                    this.$message.success(res.info||'操作成功');
                },err=>{
                    row.statusLoading = false;

                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            dangerouslyUseHTMLString: true,
                            message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
            changeAutoSend(row,val){
                console.log('changeTaskStatus',row,val);
                row.autoSendLoading = true;
                API.changeTaskAutoSend({
                    task_id:row.task_id,
                    auto_send:val,
                }).then(res=>{
                    row.autoSendLoading = false;
                    row.auto_send = val;
                    this.$message.success(res.info||'操作成功');
                },err=>{
                    row.autoSendLoading = false;

                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        this.$notify.error({
                            title: err.info||'请求失败',
                            dangerouslyUseHTMLString: true,
                            message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                });
            },
            toDetailPage(row){
                console.log('toDetailPage',row);
                this.actionRow = {...row};
                this.curShowPage = 'detail';
                this.$nextTick(()=>{
                    this.$refs.detailPage.init();
                });
            },
            editTask(data){
                this.actionType = 'edit';
                this.actionRow = {...data};
                this.curShowPage = 'create';
                this.$nextTick(()=>{
                    this.$refs.createPage.setData();
                });
            },
            startRefresh(){
                if(this.refreshTimer) return;
                this.refreshTimer = setInterval(()=>{

                    // 生成中 last_generate_status.inProgress>0    发送中 last_send_status==2
                    let dataList = this.dataList.filter(item=>{
                        let sendStatus = item.last_send_status;
                        let generateStatus = (item.last_generate_status||{}).inProgress||0;
                        return sendStatus=='2'||generateStatus > 0?item:null;
                    });
                    if(dataList.length>0) {
                        let IdsArr = dataList.map(item=>item.last_task_record_id);
                        API.getTaskSendStatus({
                            task_record_ids:IdsArr.join(',')
                        }).then(res=>{
                            let resData = res.data ||[];
                            resData.forEach(item=>{
                                let taskItem = this.dataList.find(task=>task.last_task_record_id === item.task_record_id );
                                if(taskItem){
                                    taskItem.last_send_time = item.send_time || taskItem.last_send_time;
                                    taskItem.last_send_status = item.send_status || taskItem.last_send_status;
                                    taskItem.last_generate_status = item.generate_status || taskItem.last_generate_status;
                                    taskItem.send_error_info = item.send_error_info || taskItem.send_error_info;
                                    taskItem.total_time = item.total_time ||  taskItem.total_time;
                                }
                            })
                        })
                    }
                },10*1000)
            },
            stopRefresh(){
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            },
            secondToDuration(val){
                return utils.secondToDuration(val);
            },
            isEvent(obj){
                return typeof obj === 'object' && obj !== null && 'target' in obj; // Event对象必须有target属性
            },
        },
        beforeDestroy() {
            this.stopRefresh();
        },
    }
</script>

<style lang="scss" scoped>

    .filter-bar{
        background-color: #f8f8f9;
        padding: 12px 20px 0;
        border-radius: 5px;
        ::v-deep .el-form-item{
            margin-bottom: 12px;
        }
    }

    .text-success{
        color: #619f53;
    }

    .mini-switch{
        transform: scale(0.8);
    }

    .topBtn{
        margin-left: 0;
        &.disabled{
            cursor: not-allowed!important;
            opacity: 0.6;
        }
    }
    .font12px{
        font-size: 12px;
    }

</style>
